import { createStore } from 'vuex';
import { cloneObject } from 'utils/index';
import * as user from '../modules/user';
import * as generic from '../modules/generic';
import * as productComparison from '../modules/product-comparison';
import getters from './getters';

const state = {
  fieldManifest: cloneObject(payload.fieldManifest),
  formulation: cloneObject(payload.formulation),
  shade: cloneObject(payload.shade),
  backlink: payload.backlink,
};

const store = createStore({
  modules: {
    user,
    generic,
    productComparison
  },
  state,
  getters,
});

user.init(store);
generic.init(store);

export default store;
